export const SCHEDULE_LIST = 'SCHEDULE_LIST';
export const SCHEDULE_LIST_SUCCESS = 'SCHEDULE_LIST_SUCCESS';
export const SCHEDULE_LIST_ERROR = 'SCHEDULE_LIST_ERROR';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';